<template>
  <div class="public-width">
    <div v-for="(item,index) in tabList" :key="index" @click="changeType(index,item.id)">
      <span :class="t_index===index?'active':''" class="tab" >{{item.columnType}}</span>
      <el-divider direction="vertical" v-if="index!=(tabList.length-1)"></el-divider>
    </div>
  </div>
</template>
<script>
export default {
  data(){
    return{
      t_index:-1
    }
  },
  props: {
    tabList: {
      type: Array,
      default: () => { }
    }

  },
  methods:{
    changeType(index,id){
      this.t_index=index
      this.$emit('changeType',id)
    }
  },
  created(){
    if(this.tabList[0].id!=""){    
      this.tabList.unshift({id:"",columnType:'全部'})
    }
   
    this.t_index=0
  }


}
</script>
<style lang="scss" scoped>
.public-width {
  height: 50px;
  line-height: 50px;
  background-color: #f6f6f6;
  margin-bottom: 20px;
  padding: 0 20px;
  box-sizing: border-box;
  display: flex;
  .tab {
    display: inline-block;
    width: 100px;
    text-align: center;
    cursor: pointer;
    font-size: 14px;
  }

  .active {
    font-weight: bold;
  }
}
</style>